import { render, staticRenderFns } from "./ActionPhoto.vue?vue&type=template&id=587c9286&scoped=true&"
import script from "./ActionPhoto.vue?vue&type=script&lang=js&"
export * from "./ActionPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ActionPhoto.vue?vue&type=style&index=0&id=587c9286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587c9286",
  null
  
)

export default component.exports